import 'regenerator-runtime/runtime';
import React, { useEffect } from "react";
import App from "next/app";
import { StyleSheetManager, ThemeProvider } from "styled-components";
import "bootstrap-v4-rtl/dist/css/bootstrap-rtl.min.css";
import "rc-time-picker/assets/index.css";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

import { useStore, wrapper, persistor } from "redux/store";
import { appWithTranslation } from "../i18n";
import { persistStore } from "redux-persist";

import NProgress from "nprogress";
import "nprogress/nprogress.css";
import 'filepond-plugin-image-edit/dist/filepond-plugin-image-edit.css';
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import "filepond/dist/filepond.min.css";
import "scss/index.scss";
import DefaultLayout from "app-layouts/default";
import { theme } from "app-configs/themeConfig";
import { Auth } from "auth";
import 'react-circular-progressbar/dist/styles.css';

import { PersistGate } from "redux-persist/integration/react";
// import "react-lazy-load-image-component/src/effects/blur.css";

import { useRouter } from "next/router";
import stylisRTLPlugin from "stylis-plugin-rtl";
import { Provider } from "react-redux";
import { init } from "utils/Sentry";

const MyApp = ({ Component, pageProps, err }) => {
  const Layout = (Component.config && Component.config.layout) || DefaultLayout;
  const router = useRouter();
  const store = useStore(pageProps.initialReduxState)
  const persistor = persistStore(store, {}, function () {
    persistor.persist()
  })
  init()


  useEffect(() => {
    router.events.on("routeChangeStart", function () {
      NProgress.start();
    });
    router.events.on("routeChangeComplete", function () {
      NProgress.done();
    });
    router.events.on("routeChangeError", function () {
      NProgress.remove();
    });

    return () => {
      router.events.on("routeChangeStart", function () {
        NProgress.start();
      });
      router.events.on("routeChangeComplete", function () {
        NProgress.done();
      });
      router.events.on("routeChangeError", function () {
        NProgress.remove();
      });
    };
  }, []);

  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>

        <Auth>
          <StyleSheetManager
            stylisPlugins={process.env.NEXT_PUBLIC_RTL ? [stylisRTLPlugin] : ''}
          >
            <ThemeProvider theme={theme}>
              <Layout config={Component.config}>
                <Component {...pageProps} error={err} />
              </Layout>
            </ThemeProvider>
          </StyleSheetManager>
        </Auth>
      </PersistGate>
    </Provider>

  );
};

MyApp.getInitialProps = async (appContext) => ({
  ...(await App.getInitialProps(appContext)),
});

// MyApp.getInitialProps = async ({ Component, ctx }) => {
//   console.log("hello get my app");
//   let pageProps = {};
//   if (Component.getInitialProps) {
//     pageProps = await Component.getInitialProps(ctx);
//   }
//   return { pageProps };
// };


export default appWithTranslation(MyApp);
